exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#video_container {\n    width: 100%;\n    height: 100%;\n    top:0;\n    left: 0;\n    position: fixed;\n    z-index: 9999;\n    background: rgba(0,0,0, 0.5);\n}\n.video-js {\n    margin: 0 auto;\n}\n#closeVideo {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: unset;\n    border: 0;\n    cursor: pointer;\n}\n.vjs-control-bar span {\n    color: #fff;\n}\n.vjs-icon-custombutton .vjs-icon-placeholder:before {\n    content: \"x\";\n    color: #fff;\n    font-weight: 300;\n    font-family: Arial, sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6df2a095","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/player/VideoPlayer.vue
// module id = GObC
// module chunks = 2 3 4 5 6